<div class="side-bar" *ngIf="!simpleMenu">
    <a *ngIf="!visitorPromotionImage.isDisabled&&visitorPromotionImage.image&&visitorPromotionImage.isTop"
       class="bottom-img"
       href="{{visitorPromotionImage.link}}" target="_blank">
        <img [src]="imageService.safeImage(imageService.imageSourceUrl(visitorPromotionImage.image))" width="100%"
             alt="promotional image">
    </a>

    <div class="position-wrap relative">
        <p>You are now viewing</p>
        <h1>{{command.isEventCalendar ? 'EVENTS' : 'PLACES'}}</h1>
    </div>

    <div class="sidebar-btn-wrap">
        <form ngForm="searchFormGroup" class="relative">
            <ig-field [label]="command.isEventCalendar?'search events':'search places'"
                      icon="{{searchParam.isSearching?'':'search'}}"
                      [isSearch]="true"
                      [searching]="searchParam.isSearching"
                      [isInnerLabel]="true"
                      [formControl]="searchFormGroup.get('searchText')"
                      [(ngModel)]="searchText"
                      (onClear)="clearSearchText()"
                      (keyup)="search($event)">
            </ig-field>
            <ig-alt-button (trigger)="search($event)" (cancel)="clearSearchText()"></ig-alt-button>
        </form>

        <ig-button class="map-btn long-btn" id="map-btn" (trigger)="viewChange()">
            <span>CLICK FOR {{command.isMapView ? 'CALENDAR' : 'MAP'}} VIEW</span>
            <mat-icon role="img" class="notranslate" translate="no">room</mat-icon>
        </ig-button>

        <ng-container *ngIf="command.isEventCalendar&&isEventEnabled">
            <ig-event-filter #eventFilter mode="sidebar"
                             [isHideEditorChoice]="isHideEditorChoice"
                             [customEvents]="customEvents" (onFilter)="searchText=''"></ig-event-filter>

            <ig-button *ngIf="featuresToggle.manualEvents" class="map-btn long-btn" (trigger)="addEventsManually()">
                <span class="notranslate" translate="no">Submit Your Event</span>
                <mat-icon>input</mat-icon>
            </ig-button>

        </ng-container>

        <ng-container *ngIf="!command.isEventCalendar">

            <ig-custom-default-place-category-accordion
                #placeCategoryAccordion
                *ngIf="customDefaultPlaceCategory"
                [toggleAndSource]="toggleAndSource"
                [selectedCategory]="category"
                [menuType]="menuType"
                (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                (onNormalCategoryClick)="filterPlace($event)"
                [customDefaultPlaceCategory]="customDefaultPlaceCategory"
            ></ig-custom-default-place-category-accordion>

            <ig-custom-place-btn #customPlaceBtn (onCustomPlaceSelected)="category='All';placeCategoryAccordion&&placeCategoryAccordion.clearFilter()"></ig-custom-place-btn>

            <ig-button class="map-btn long-btn" (trigger)="addPlacesManually()">
                <span class="notranslate" translate="no">Submit Your Place</span>
                <mat-icon>input</mat-icon>
            </ig-button>
        </ng-container>

        <ig-powered-by [style]="'iti-horizontal'"></ig-powered-by>

    </div>

    <div class="side-bar simple-side-bar" *ngIf="simpleMenu">
        <a *ngIf="visitorPromotionImage.image&&visitorPromotionImage.isTop" class="bottom-img"
           href="{{visitorPromotionImage.link}}" target="_blank">
            <img [src]="imageService.safeImage(imageService.imageSourceUrl(visitorPromotionImage.image))" width="100%"
                 alt="promotional">
        </a>

        <div mat-icon-button class="go-back" (click)="close()">
            <mat-icon>arrow_back</mat-icon>
        </div>
        <div>
            <ig-row class="login-with-fb">
                <ig-col [xs]="6">
                    <span>{{command.isEventCalendar ? 'EVENTS' : 'PLACES'}}</span>
                </ig-col>
                <ig-col [xs]="6">
                    <!--<ig-fb-login-btn #loginWithFBBtn></ig-fb-login-btn>-->
                </ig-col>
            </ig-row>
        </div>

        <div class="btn-wrap">
            <ig-button class="long-btn" (trigger)="viewChange()">
                <span>CLICK FOR MAP VIEW</span>
                <mat-icon class="notranslate" translate="no">room</mat-icon>
            </ig-button>
        </div>

        <form ngForm="searchFormGroup" class="search-wrap">
            <ig-mat-field label="search place"
                          [(ngModel)]="searchText"
                          (keyup)="search($event)"
                          [formControl]="searchFormGroup.get('searchText')">
            </ig-mat-field>
            <mat-icon class="notranslate" translate="no">search</mat-icon>
            <ig-alt-button (trigger)="search($event)" (cancel)="clearSearchText()"></ig-alt-button>
        </form>

    </div>

    <a *ngIf="!visitorPromotionImage.isDisabled&&visitorPromotionImage.image&&!visitorPromotionImage.isTop"
       class="bottom-img"
       href="{{visitorPromotionImage.link}}" target="_blank">

        <img [src]="imageService.safeImage(imageService.imageSourceUrl(visitorPromotionImage.image))" width="100%"
             alt="promotional">
    </a>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/side.bar/visitor.side.bar.component.html